import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { IPayloadPayeeMatchParameters } from 'src/app/shared/models/payeeMatchParameters.model'
import * as yup from 'yup'

const RegexConfidenceScore = /^(80|8[1-9]|9[0-9]|100)$/

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    profileName: yup.string().required(
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: t('PayeeMatchParameters:addNewPayeeMatchParameters.label.profileName'),
      }),
    ),
    createExceptionsForConfidenceScoresBelowDefault: yup
      .string()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: t(
            'PayeeMatchParameters:addNewPayeeMatchParameters.label.createExceptionsForConfidenceScoresBelowDefault',
          ),
        }),
      )
      .matches(RegexConfidenceScore, t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_PARAMETER)),

  })
  return validationSchema
}

const formatDataBeforeSubmit = (data: IPayloadPayeeMatchParameters) => {
  return {
    ...data,
    name: data?.profileName.trim(),
    createExceptionsForConfidenceScoresBelowDefault: Number(data?.createExceptionsForConfidenceScoresBelowDefault),
  }
}

const handleInputChange = (e: any, field: any) => {
  let inputValue = e.target.value
  inputValue = inputValue.trim().replace(/[^0-9.]/g, '')

  const maxLength = 14
  if (inputValue.split('.')[0].length > maxLength) {
    inputValue = inputValue.slice(0, maxLength)
  }

  const decimalPart = inputValue.split('.')[1] || ''
  if (decimalPart.length > 2) {
    inputValue = inputValue.slice(0, inputValue.lastIndexOf('.') + 3)
  }

  field.onChange(inputValue)
}

function mappingData(data: any) {
  const { profileName, createExceptionsForConfidenceScoresBelowDefault, detectAdditionalNames, enterAdditionalNames } =
    data

  return {
    profileName,
    createExceptionsForConfidenceScoresBelowDefault: String(createExceptionsForConfidenceScoresBelowDefault),
    detectAdditionalNames,
    enterAdditionalNames,
  }
}

// function formatCurrency(value: number): string {
//   return value.toLocaleString('en-US', {
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//     style: 'decimal',
//     currency: 'USD',
//   });
// }

function mappingDataViewOnly(data: any) {
  const { profileName, createExceptionsForConfidenceScoresBelowDefault, detectAdditionalNames, enterAdditionalNames } =
    data

  return {
    profileName,
    createExceptionsForConfidenceScoresBelowDefault,
    detectAdditionalNames,
    enterAdditionalNames,
  }
}

export { formatDataBeforeSubmit, generateValidationSchema, handleInputChange, mappingData, mappingDataViewOnly }
